import { Component, effect, input, signal } from "@angular/core";
import {
  AppResizeEvent,
  ResizeDirective,
} from "src/app/directives/resize.directive";
import { LoadingIndicatorComponent } from "../../utils/loading-indicator/loading-indicator.component";
import {
  PDFInfo,
  PdfViewerComponent,
} from "../pdf-viewer/pdf-viewer.component";

@Component({
  selector: "app-paged-pdf-viewer",
  templateUrl: "./paged-pdf-viewer.component.html",
  styles: ``,
  imports: [ResizeDirective, LoadingIndicatorComponent, PdfViewerComponent],
})
export class PagedPdfViewerComponent {
  pdfUrl = input.required<string>();

  pageNumber = -1;

  numPages = 0;

  pdfWidth = 0;
  pdfHeight = 0;

  hasRenderedFirstPage = false;

  minHeight = input<number>(1080);

  cutoffWidth = input<number>(1000000); // XXX: investigate: it was 1024 which broke the pdf size!

  lastResizeEvent = signal<AppResizeEvent | undefined>(undefined);

  showPageNumberOnLastPage = input.required<boolean>();

  constructor() {
    effect(() => {
      const minHeight = this.minHeight();
      const cutoffWidth = this.cutoffWidth();
      const event = this.lastResizeEvent();
      const minDiff = 25;

      const setWidthAndHeight = (width: number, height: number) => {
        if (
          Math.abs(this.pdfHeight - height) > minDiff &&
          Math.abs(this.pdfWidth - width) > minDiff
        ) {
          this.pdfHeight = height;
          this.pdfWidth = width;
        }
      };

      if (event) {
        const width = Math.floor(event.width);
        const height = Math.max(Math.floor(event.height), minHeight); // at the beginning the container has no height, therefore we should at least make the pdf-height "minHeight"

        if (width > cutoffWidth) {
          setWidthAndHeight(cutoffWidth, (width / height) * cutoffWidth); // XXX: this caused the pdf to be broken on large screens!!
        } else {
          setWidthAndHeight(width, height);
        }
      }
    });
  }

  handleResized(event: AppResizeEvent) {
    this.lastResizeEvent.set(event);
  }

  pdfLoaded(pdf: PDFInfo) {
    this.numPages = pdf.numPages;
    this.pageNumber = 1;
  }

  handleFirstPageRendered() {
    this.hasRenderedFirstPage = true;
  }
}
